import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that shows a live-updating surcharge note tied to the
 * selected variant's `custom.addon_surcharge_note` metafield.
 * Mirrors the update pattern used by `product-price.js`.
 */
class AddonSurchargeNote extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html } = detail;

        const newEl = html.querySelector(`addon-surcharge-note[data-block-id="${this.dataset.blockId}"]`);
        if (!newEl) return;

        const { note } = this.refs;
        const newNote = newEl.querySelector('[ref="note"]');
        if (note && newNote) {
          note.replaceWith(newNote);
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[addon-surcharge-note] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('addon-surcharge-note')) {
  customElements.define('addon-surcharge-note', AddonSurchargeNote);
}
